import React from "react";
import { useParams } from "react-router";
import RecipeError from "./recipe-error";
import RecipeInfo from './recipe-info';

import RecipeList from "../../recipes-list";

function Recipe() {
  let { id } = useParams();

  if (id > RecipeList.length) {
    return <RecipeError />;
  } else {
    let currentRecipe = RecipeList[id - 1];

    return (
      <RecipeInfo recipeDetails={currentRecipe}/>
    );
  }
}

export default Recipe;
